
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import { TranslateResult } from 'vue-i18n';

interface BreadCrumbItem {
  text: string | TranslateResult;
  to: string;
  disabled: boolean;
}

@Component
export default class BreadCrumb extends Vue {
  public $route!: Route;

  get items() {
    const routeParts: string[] = this.$route.name!.split('.');
    const items: BreadCrumbItem[] = [];

    if (routeParts.length >= 2 && routeParts[routeParts.length - 1] !== 'index') {
      const routePart: string = routeParts.length === 2 ? routeParts[0] : routeParts.slice(0, -1).join('.');

      items.push({
        text: this.$t(`routes.${routePart}.index`),
        to: `${routePart}.index`,
        disabled: false,
      });
    }

    items.push({
      text: this.$t(`routes.${this.$route.name}`),
      to: this.$route.name!,
      disabled: true,
    });

    return items;
  }
}
